import { Stack, AppBar, Box, Toolbar } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import styles from "../Layout.module.css";
import { Fragment, useEffect, useState } from "react";
import { AppBarEnum } from "../../../core/enumerations/AppBarEnum";
import { mobileFooterMenu } from "../../../core/json/FooterMenuJson";
import UploadTooltip from "../../../pages/upload/upload-tooltip/UploadTooltip";

export const MobileFooter = () => {
  const location: any = useLocation();

  const [selectedPath, setSelectedPath] = useState("");

  const handleMenuPath = (event: any, label: string) => {
    if (label === AppBarEnum.post) {
      setSelectedPath(label);
    } else {
      setSelectedPath("");
    }
  };

  useEffect(() => {
    if (location.pathname === "/upload") {
      setSelectedPath("MobileUpload");
    }
    if (location.pathname === "/notifications") {
      setSelectedPath("Notifications");
    }
    if (location.pathname.includes("/profile/others-profile")) {
      setSelectedPath("Others");
    }
  }, [location.pathname]);

  return (
    <AppBar
      position="fixed"
      sx={{ top: "auto", bottom: 6 }}
      className={styles["mobile-footer"]}
    >
      <Toolbar disableGutters={true}>
        <Box
          sx={{
            display: {
              xs: "block",
              sm: "block",
              md: "none",
              lg: "none",
              xl: "none",
            },
            width: { xs: "88%" },
            m: "auto",
            paddingTop: "8px",
          }}
        >
          <Stack
            rowGap={5}
            sx={{
              justifyContent: { xs: "space-between" },
              width: { xs: "100%" },
            }}
          >
            {mobileFooterMenu.map((item: any, index: number) => {
              return (
                <NavLink
                  key={index}
                  to={item.path}
                  className={({ isActive }) =>
                    isActive || location === item.path
                      ? styles["menu-item-active"]
                      : styles["menu-item"]
                  }
                  children={({ isActive }) => (
                    <Fragment>
                      <img
                        className={styles["nav-menu-icons"]}
                        src={
                          (isActive || location === item.path) &&
                          selectedPath !== "Others"
                            ? item.activeIcon
                            : item.icon
                        }
                        alt="nav-menu-icons"
                        onClick={(event) => handleMenuPath(event, item.label)}
                      />
                    </Fragment>
                  )}
                />
              );
            })}
          </Stack>
          {selectedPath == "MobileUpload" && (
            <Stack
            // sx={{
            //   position: "absolute",
            //   right: { xs: "20%", sm: "35%" },
            //   // top: "-130px",
            // }}
            >
              <UploadTooltip
                setSelectedPath={setSelectedPath}
                isMobile={true}
              />
            </Stack>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
function setSelectedPath(label: string) {
  throw new Error("Function not implemented.");
}
